/*
 * @Author: wangshengqiang
 * @Date: 2021-06-17 19:48:08
 * @LastEditTime: 2021-07-01 15:04:22
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import classnames from 'classnames';
const TabsModule = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    Render,
    children
  } = props;
  const cls = classnames({
    'components-tabs-module-render': true
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cls
  }, /*#__PURE__*/React.createElement(Render, {
    components: children
  }));
});
TabsModule.propTypes = {};
TabsModule.defaultProps = {};
export default TabsModule;